import React, {Component} from 'react'
import {Loader} from 'semantic-ui-react'
import Utils from '../../modules/utils'

class ReportProcessing extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.interval = setInterval(this.checkReport, 5000)
  }

  checkReport = () => {
    let {reportId, fieldOnChange} = this.props
    Utils.get(`check_report/${reportId}`, (err, res) => {
      if (err) {
        alert('There was an error when trying to check report.')
      } else {
        let {url} = res.data

        if (url != null) {
          window.location = res.data.url
          clearInterval(this.interval)
          fieldOnChange(null, {value: null, name: 'reportId'}, false)
        }
      }
    })
  }

  render() {
    let {reportId} = this.props
    return (
      <div style={{position: 'fixed', left: 0, padding: '10px', border: '1px solid rgb(230,230,230)', borderRadius: '2px', background: 'white', top: '75px', zIndex: 9, width: '100%', boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.05)'}}>
        Report Processing, ID = {reportId} <Loader active inline size='mini' />
      </div>
    )
  }
}

export default ReportProcessing
